export const projectsData = [
  
  {
    id: 0,
    title: "Client website revamp",
    description:
      "Transformed a static HTML, CSS, and JS website into a dynamic, modern web application using React for the frontend and Django for the backend. Enhanced user experience, interactivity, and maintainability for seamless client engagement.",
    technologies: ["ReactJs", "Django", "Bootstrap"],
    img: require("../../media/rimr.png"),
  },
  {
    id: 1,
    title: "WeatherWear",
    description:
      "Crafted a weather application that provides real-time weather updates and recommends suitable outfits, ensuring users are stylish and weather-ready. Seamlessly blends functionality and aesthetics for a delightful user experience.",
    technologies: ["ReactJs", "APIs", "SCSS"],
    img: require("../../media/weatherwear.png"),
  },
  {
    id: 2,
    title: "MastersGuide",
    description:
      " Developed an all-encompassing Masters guide app, aiding students with entry guidance, resume reviews, insights from past applicants, application improvement suggestions, and detailed university acceptance criteria. Streamlining the end-to-end application process for student success.",
    technologies: ["ReactJs", "Flask", "Bootstrap"],
    img: require("../../media/mastersguide.png"),
  },
];
